export const assistancesEs = [
  { id: '1', value: 'No' },
  { id: '13', value: 'No, pero necesito ayuda (puerta a puerta)' },
  { id: '4', value: 'Silla de ruedas (no se puede transferir)' },
  { id: '15', value: 'Silla de ruedas (se puede transferir)' },
  { id: '3', value: 'Andador' },
  { id: '6', value: 'Necesito una camilla' },
];
